"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./util/decorators"));
var bundler_1 = require("./util/bundler");
exports.bundle = bundler_1.bundle;
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-metadata/src/core/util.js
// module id = 510
// module chunks = 6